<template>
  <div>
    <v-select
      label="知识产权类型"
      v-model="inteTypeId"
      item-text="name"
      item-value="dbid"
      :items="inteTypeItems"
      @change="onInteTypeChange"
    />
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
  import {Bar, Line, mixins} from 'vue-chartjs'

  const uri = '/api/inte/report/five-year-by-type';

  export default {
    extends: Bar,
    mixins: [mixins.reactiveData],
    data() {
      return {
        inteTypeId: '',
        inteTypeItems: [],
        inteTypeLoading: false,

        chartData: null,
        options: {
          responsive: true,
          title: {
            display: false,
            text: ''
          },
          tooltips: {
            mode: 'index',
            intersect: false,
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: '年度'
              }
            }],
            yAxes: [{
              id: 'y-axis-1',
              type: 'linear',
              display: true,
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: '数量'
              },
              ticks:{
                beginAtZero: true,
              }
            }]
          }
        }
      }
    },
    created() {

      const vm = this;
      const param = {"sort": "rank.asc", "limit": 999};

      vm.inteTypeLoading = true;
      this.axios.get("/api/inte/intellectualType/", {params: param})
        .then(
          rsp => {
            vm.inteTypeLoading = false;
            vm.inteTypeItems = rsp.data.items;
            vm.inteTypeId = 'Df_FSfJAAAA';
            vm.onInteTypeChange('Df_FSfJAAAA');
          })
    },
    mounted() {
      this.renderChart(this.chartData, this.options)
    },
    methods: {
      onInteTypeChange(typeId) {
        const vm = this;
        const param = {"typeId": typeId};

        this.axios.get(uri, {params: param})
          .then(
            rsp => {
              vm.chartData = rsp.data;
            })
      }
    }
  }
</script>

<style scoped>

</style>
